import React from 'react';
import { CADS, QTYPES, getCadenceProgress } from '../constants';
import CBadge from './CBadge';

const pickDiverseBets = (bets, max = 5) => {
  const picked = [];
  const seenEntities = new Set();
  const seenCriteria = new Set();
  const remaining = [...bets];

  // Pass 1: unseen entity + unseen criteria
  for (let i = remaining.length - 1; i >= 0 && picked.length < max; i--) {
    const b = remaining[i];
    if (!seenEntities.has(b.entity) && !seenCriteria.has(b.criteria)) {
      seenEntities.add(b.entity);
      seenCriteria.add(b.criteria);
      picked.push(b);
      remaining.splice(i, 1);
    }
  }
  // Pass 2: unseen entity + seen criteria
  for (let i = remaining.length - 1; i >= 0 && picked.length < max; i--) {
    const b = remaining[i];
    if (!seenEntities.has(b.entity)) {
      seenEntities.add(b.entity);
      picked.push(b);
      remaining.splice(i, 1);
    }
  }
  // Pass 3: seen entity + unseen criteria
  for (let i = remaining.length - 1; i >= 0 && picked.length < max; i--) {
    const b = remaining[i];
    if (!seenCriteria.has(b.criteria)) {
      seenCriteria.add(b.criteria);
      picked.push(b);
      remaining.splice(i, 1);
    }
  }
  // Pass 4: fill remaining slots
  if (picked.length < max) {
    picked.push(...remaining.slice(0, max - picked.length));
  }
  return picked;
};

export default function MarketSection({ mTab, setMTab, cadTab, setCadTab, curCad, curBets, fBets, xp, setXp, tip, toggleTip, openBet, showToast, fetchAll }) {
  return (
    <section style={{ marginTop: 24 }}>
      <div style={{ marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid var(--bs-border, #1a1a1a)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
          <h2 style={{ fontSize: 24, fontFamily: "Dela Gothic One", color: "var(--bs-ink, #fff)" }}>PayDirt Markets</h2>
          <span style={{ fontSize: 9, fontFamily: "JetBrains Mono", fontWeight: 700, color: "#ff1744", background: "#ff174422", border: "1px solid #ff174444", borderRadius: 4, padding: "2px 6px", display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#ff1744", animation: "pulse 1.5s infinite", display: "inline-block" }} />LIVE
          </span>
        </div>
        <p style={{ fontSize: 13, color: "var(--bs-body, #d1d5db)", fontWeight: 500 }}>Take a position on the credibility of the news</p>
      </div>

      {/* Source / Author */}
      <div style={{ display: "flex", marginBottom: 12, borderBottom: "1px solid var(--bs-border, #1a1a1a)" }}>
        {[{ id: "sources", l: "Outlets", sub: "News organizations" }, { id: "authors", l: "Reporters", sub: "Individual reporters" }].map(t => (
          <button key={t.id} onClick={() => setMTab(t.id)} style={{ padding: "10px 20px", background: "none", border: "none", cursor: "pointer", fontSize: 12, fontFamily: "JetBrains Mono", fontWeight: mTab === t.id ? 700 : 400, letterSpacing: 1, color: mTab === t.id ? "var(--bs-amber, #ffab00)" : "var(--bs-muted, #555)", borderBottom: mTab === t.id ? "2px solid var(--bs-amber, #ffab00)" : "2px solid transparent", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <span>{t.l}</span>
            {t.sub && <span style={{ fontSize: 8, color: mTab === t.id ? "var(--bs-amber, #ffab0088)" : "var(--bs-muted, #333)", marginTop: 1 }}>{t.sub}</span>}
          </button>))}
      </div>

      {(mTab === "sources" || mTab === "authors") && <>
        {/* Cadence tabs */}
        <div style={{ display: "flex", gap: 6, marginBottom: 16 }}>
          {CADS.map(cad => {
            const active = cadTab === cad.id;
            const cadBets = fBets(cad.id);
            const cnt = QTYPES.reduce((sum, qt) => sum + pickDiverseBets(cadBets.filter(b => b.questionType === qt.id)).length, 0);
            const prog = getCadenceProgress(cad.id);
            return (
              <button key={cad.id} onClick={() => setCadTab(cad.id)} style={{ flex: 1, padding: "10px 8px", borderRadius: 8, border: active ? `1px solid ${cad.color}55` : "1px solid var(--bs-border, #1a1a1a)", background: active ? cad.color + "12" : "var(--bs-surface, #111)", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, transition: "all .15s" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <span style={{ fontSize: 14 }}>{cad.icon}</span>
                  <span style={{ fontSize: 12, fontFamily: "JetBrains Mono", fontWeight: 700, color: active ? cad.color : "var(--bs-muted, #555)", letterSpacing: 1 }}>{cad.label.toUpperCase()}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 10, fontFamily: "JetBrains Mono", color: "var(--bs-muted, #9ca3af)" }}>
                  <span>{cnt} bets</span><span style={{ fontSize: 12, fontWeight: 700 }}>·</span><span>{prog.label}</span>
                </div>
                <div style={{ width: "100%", height: 3, background: "var(--bs-border, #1a1a1a)", borderRadius: 2, overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${prog.pct}%`, background: active ? cad.color : cad.color + "44", borderRadius: 2, transition: "width .3s" }} />
                </div>
              </button>);
          })}
        </div>

        {/* Markets grouped by question type */}
        {curBets.length === 0 ? (
          <div style={{ background: "var(--bs-surface, #111)", border: "1px dashed var(--bs-border, #222)", borderRadius: 12, padding: "24px 16px", textAlign: "center" }}>
            <span style={{ fontSize: 20, opacity: .3, display: "block", marginBottom: 8 }}>⏳</span>
            <span style={{ fontSize: 12, color: "var(--bs-muted, #444)", fontFamily: "JetBrains Mono" }}>
              No {mTab} markets for {curCad?.label.toLowerCase()} cadence yet
            </span>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {QTYPES.map(qt => {
              const typeBets = curBets.filter(b => b.questionType === qt.id);
              if (typeBets.length === 0) return null;
              const k = `${cadTab}-${qt.id}`;
              const isExpanded = xp[k + '-qtfull'];
              const qEntities = [...new Set(typeBets.map(b => b.entity))];

              return (
                <div key={qt.id}>
                  <button onClick={() => setXp(prev => ({ ...prev, [k + '-qtfull']: !prev[k + '-qtfull'] }))}
                    style={{ width: "100%", background: "none", border: "none", cursor: "pointer", padding: "8px 4px 10px", borderBottom: `1px solid ${qt.color}22`, marginBottom: isExpanded ? 8 : 0, display: "flex", alignItems: "center", gap: 8, textAlign: "left" }}>
                    <span style={{ fontSize: 10, color: "var(--bs-muted, #555)", transition: "transform .2s", transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)", display: "inline-block" }}>▾</span>
                    <span style={{ fontSize: 18, ...(qt.id === 'threshold' ? { animation: 'arrowSlide 1.5s ease-in-out', display: 'inline-block' } : {}) }}>{qt.icon}</span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 14, fontFamily: "JetBrains Mono", fontWeight: 700, color: qt.color, letterSpacing: 1 }}>{qt.label.toUpperCase()}</span>
                        <span style={{ fontSize: 10, fontFamily: "JetBrains Mono", color: "var(--bs-muted, #555)", background: "var(--bs-border, #1a1a1a)", padding: "1px 6px", borderRadius: 8 }}>{pickDiverseBets(typeBets).length}</span>
                      </div>
                      <div style={{ fontSize: 12, color: "var(--bs-muted, #9ca3af)", marginTop: 2 }}>{qt.id === "head_to_head" ? `● ${mTab === "authors" ? "Reporter" : "Outlet"} vs. ${mTab === "authors" ? "Reporter" : "Outlet"} matchup` : qt.desc}</div>
                      {!isExpanded && <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
                        {qEntities.map(name => (
                          <span key={name} style={{ fontSize: 8, padding: "2px 6px", borderRadius: 8, background: "var(--bs-border, #1a1a1a)", color: "var(--bs-body, #888)", fontFamily: "JetBrains Mono" }}>{name}</span>
                        ))}
                      </div>}
                    </div>
                  </button>

                  {isExpanded && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {pickDiverseBets(typeBets).map(b => {
                        const pyP = b.yesPct;
                        return (
                          <div key={b.id} style={{ background: "var(--bs-surface, #111)", border: "1px solid var(--bs-border, #1a1a1a)", borderRadius: 10, padding: "10px 12px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                              <span style={{ fontSize: 12, fontWeight: 700, color: "var(--bs-ink, #fff)" }}>{b.entity}</span>
                              {b.entityB && <><span style={{ fontSize: 9, fontWeight: 800, color: "var(--bs-ink, #e5e7eb)", border: "1px solid var(--bs-border, #4b5563)", borderRadius: 3, padding: "1px 4px", letterSpacing: "0.1em", textTransform: "uppercase", fontFamily: "JetBrains Mono" }}>VS</span><span style={{ fontSize: 12, fontWeight: 700, color: "var(--bs-ink, #fff)" }}>{b.entityB}</span></>}
                              <CBadge criteria={b.criteria} id={b.id + "-badge"} tip={tip} toggleTip={toggleTip} />
                            </div>
                            <p style={{ fontSize: 11, color: "var(--bs-body, #d1d5db)", fontWeight: 500, lineHeight: 1.3, marginBottom: 6 }}>{b.q}</p>
                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                              <span style={{ fontSize: 8, fontFamily: "JetBrains Mono", color: "var(--bs-green, #00e676)" }}>YES ${(b.yV / 1000).toFixed(0)}K</span>
                              <span style={{ fontSize: 8, fontFamily: "JetBrains Mono", color: "var(--bs-red, #ff1744)" }}>NO ${(b.nV / 1000).toFixed(0)}K</span>
                            </div>
                            <div style={{ height: 2, background: "#ff174433", borderRadius: 2, overflow: "hidden", marginBottom: 6 }}>
                              <div style={{ height: "100%", width: `${pyP}%`, background: "var(--bs-green, #00e676)", borderRadius: 2 }} />
                            </div>
                            <div style={{ display: "flex", gap: 3 }}>
                              <button onClick={(e) => { e.stopPropagation(); openBet(b, "yes"); }} style={{ flex: 1, padding: "6px 8px", borderRadius: 5, border: "1px solid var(--bs-green-bd, #00e67644)", background: "var(--bs-green-bg, #00e67611)", color: "var(--bs-green, #00e676)", cursor: "pointer", fontFamily: "JetBrains Mono", fontSize: 10, display: "flex", justifyContent: "space-between" }}><span style={{ fontWeight: 700 }}>YES</span><span style={{ opacity: .7 }}>{Math.round(b.yesPct)}¢</span></button>
                              <button onClick={(e) => { e.stopPropagation(); openBet(b, "no"); }} style={{ flex: 1, padding: "6px 8px", borderRadius: 5, border: "1px solid var(--bs-red-bd, #ff174444)", background: "var(--bs-red-bg, #ff174411)", color: "var(--bs-red, #ff1744)", cursor: "pointer", fontFamily: "JetBrains Mono", fontSize: 10, display: "flex", justifyContent: "space-between" }}><span style={{ fontWeight: 700 }}>NO</span><span style={{ opacity: .7 }}>{Math.round(b.noPct)}¢</span></button>
                            </div>
                          </div>);
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </>}

    </section>
  );
}
